import { useState } from "react";
import { RadioButton } from "../../atoms/RadioButton";
import { Label } from "../../atoms/Label";
import { InlineErrorMessage } from "@components/atoms/Errors/InlineErrorMessage";

export type RadioOptionsProps = {
  id: string;
  className?: string;
  name?: string;
  labelTextOptionOne: string;
  labelTextOptionTwo: string;
  subtextOptionOne?: string;
  subtextOptionTwo?: string;
  title?: string;
  errorMessage?: string;
  onChange: (result: string) => void;
  yesRef?:
    | React.RefObject<HTMLInputElement>
    | React.MutableRefObject<HTMLInputElement>
    | null;
  noRef?:
    | React.RefObject<HTMLInputElement>
    | React.MutableRefObject<HTMLInputElement>
    | null;
};
/**
 * Yes/No option component consists of 2 radio buttons
 *
 * @category Radio
 * @props result(result: string): void
 */
export const RadioOptions = (props: RadioOptionsProps) => {
  const [radio, setRadio] = useState("");

  return (
    <div className="mb-1 mt-4">
      <div className={`mb-6 text-2xl font-semibold ${props.className}`}>
        {props.title}
      </div>
      <InlineErrorMessage message={props.errorMessage} />
      <div className="mt-4 flex items-center">
        <RadioButton
          id={props.id + `yes`}
          name={(props.name || "") + `yes`}
          value="true"
          ref={props.yesRef}
          checked={radio === "true"}
          onChange={(e) => {
            setRadio(e.target.value);
            props.onChange(props.labelTextOptionOne);
          }}
        />
        <div className="font-semibold">
          <Label
            className="radio-label"
            htmlFor={props.id + "yes"}
            text={props.labelTextOptionOne}
          />
        </div>
      </div>
      <div className={"ml-14 max-w-lg"}>
        {props?.subtextOptionOne !== null && (
          <pre className="body-3 max-w-lg whitespace-pre-wrap">
            {props.subtextOptionOne}
          </pre>
        )}
      </div>
      <div className="mt-6 flex items-center">
        <RadioButton
          id={props.id + "no"}
          ref={props.noRef}
          name={(props.name || "") + "no"}
          value="false"
          checked={radio === "false"}
          onChange={(e) => {
            setRadio(e.target.value);
            props.onChange(props.labelTextOptionTwo);
          }}
        />
        <div className="font-semibold">
          <Label
            className="radio-label"
            htmlFor={props.id + "no"}
            text={props.labelTextOptionTwo}
          />
        </div>
      </div>
      <div className={"ml-14 max-w-lg"}>
        {props?.subtextOptionTwo !== null && (
          <pre className="body-3 max-w-lg whitespace-pre-wrap">
            {props.subtextOptionTwo}
          </pre>
        )}
      </div>
    </div>
  );
};
